import { render, staticRenderFns } from "./EmployeeSignUpAddEdit.vue?vue&type=template&id=32fd70f8"
import script from "./EmployeeSignUpAddEdit.vue?vue&type=script&lang=js"
export * from "./EmployeeSignUpAddEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports